export default IconGridGoldenratio => `<svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-grid-goldenratio" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
  <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
  <path d="M3 10h18" />
  <path d="M3 14h18" />
  <path d="M10 3v18" />
  <path d="M14 3v18" />
</svg>`;